import React from "react"
import PropTypes from "prop-types"
import Input from "../../../../Input/Input"
import { sanitizeAmount } from "../../../../../helpers/sanitizeAmount"
import styles from "./index.module.scss"

/** Free text min/max currency inputs; only digits and a decimal point are kept. */
const ValueRange = ({ min, max, onChangeMin, onChangeMax }) => (
  <div className={styles.range}>
    <p className={styles.title}>Opportunity Value</p>
    <div className={styles.inputs}>
      <Input
        name="value_min"
        className={styles.input}
        type="text"
        inputMode="decimal"
        placeholder="Min"
        aria-label="Minimum opportunity value"
        value={min}
        onChange={(e) => onChangeMin(sanitizeAmount(e.target.value))}
      />
      <span className={styles.dash}>-</span>
      <Input
        name="value_max"
        className={styles.input}
        type="text"
        inputMode="decimal"
        placeholder="Max"
        aria-label="Maximum opportunity value"
        value={max}
        onChange={(e) => onChangeMax(sanitizeAmount(e.target.value))}
      />
    </div>
    {min && max && Number(min) > Number(max) && (
      <p className={styles.error}>Min should not exceed max</p>
    )}
  </div>
)

ValueRange.propTypes = {
  min: PropTypes.string,
  max: PropTypes.string,
  onChangeMin: PropTypes.func.isRequired,
  onChangeMax: PropTypes.func.isRequired,
}

export default ValueRange
